import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';
import { STATUS_CHOICES, USER_ROLE_BY_KEY } from 'configs/Constant';
import { createPersister } from 'react-query';

const useArtworksSoldDonated = (userUuid) => {
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);
  const role = useSelector((state) => state.auth.account.user?.role);

  const params = {
    ...objectParamsFromSearchParams,
    user_uuid: userUuid,
    status__in: `${STATUS_CHOICES.SOLD},${STATUS_CHOICES.DONATED_GIFTED}`,
  };

  const apiUrl =
    role === USER_ROLE_BY_KEY.COLLECTOR
      ? API.ARTWORK.LIST_COLLECTOR_SOLD_DONATED
      : API.ARTWORK.ARTWORK;

  return useQuery({
    queryKey: [apiUrl, params],
    persister: createPersister(),
  });
};

export default useArtworksSoldDonated;
